import { Component, OnInit, Input, Renderer2, ElementRef } from '@angular/core';
import { Projection } from '../core/models/projection.model';

@Component({
  selector: 'app-player-card',
  templateUrl: './player-card.component.html',
  styleUrls: ['./player-card.component.scss']
})
export class PlayerCardComponent implements OnInit {

  @Input() player: Projection;

  constructor(private _renderer: Renderer2) { }

  ngOnInit() {
  }

  public toggleDrafted(event: any, element: ElementRef) {
    const cssClass = 'drafted';

    if ( event.target.parentNode.classList.contains(cssClass) ) {
      this._renderer.removeClass(element, 'drafted');
    } else {
      this._renderer.addClass(element, 'drafted');
    }
  }
}
